/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const NDC_TABS_DATA = [
  { name: 'NDC', value: 'ndc' },
  { name: 'Name', value: 'name' },
  { name: 'Labeler', value: 'labeler' },
];

export const NDC_DETAILS_TAB_DATA = [
  { label: 'CMS Drug', value: 'CMS Drug' },
  { label: 'CMS UROA', value: 'cms_uroa' },
  { label: 'CMS COD', value: 'CMS COD' },
  { label: 'CMS DESI', value: 'cms_desi' },
  { label: 'NDC Detail', value: 'ndc_detail' },
  { label: 'Price', value: 'price' },
];
